
import { useContext } from '@nuxtjs/composition-api';
import useTlmCart from './useTlmCart';
import useCategories from './useCategories';

const formatItemData = ({ item, categorySlug, image }) => ({
  itemId: item.cartProduct?.id,
  itemSku: item.sku,
  itemName: item.cartProduct?.name,
  itemPrice: item.cartProduct?.selectedPrice?.basePrice || item.cartProduct?.selectedPrice?.lineItemPrice,
  itemQuantity: 1,
  itemVariant: item.cartProduct?.variantKey,
  itemCategoryName: categorySlug,
  // itemGoalId: '',
  itemProductUrl: categorySlug ? `https://telmore.dk/shop/${categorySlug}/${item.cartProduct?.brandName}/${item.cartProduct?.slug}` : '',
  itemImageUrl: image ? 'https:' + image + '?w=300' : ''
})


const formatData = ({ hltid, order, getCategoryForCartItemGroup, getCategorySlugById }) => {
  const items = order?.value?.cartItemGroupList?.flatMap(group => group.cartItems.map(item => {
    const categoryId = getCategoryForCartItemGroup(group.groupId) || ''
    const categorySlug = getCategorySlugById(categoryId) || ''
    const image = item.cartProduct?.productContent?.productImages?.at(0)?.imageUrl

    return formatItemData({ item, categorySlug, image })
  }))

  const data = {
    hltid,
    // orderSubTotal: 123.456,
    // offerId: '',
    // goalId: '',
    orderId: order?.value?.orderCompletedId,
    // orderShipping: 200,
    // orderTax: 400.125,
    orderTotal: order?.value?.totalCartPriceInKR,
    orderCurrencyCode: 'DKK',
    // orderCouponCode: 'MH2021',
    // orderDiscount: 10.25,
    orderItems: items,
    marketingTags: []
  }

  if (process.client && window) {
    window.hlconversion = data
  }

  return data
}

export default function useHeylink () {
  /**
   * @param {object} query object
   */
  const storeParamsToSession = (query) => {
    const heylinkParams = {
      hltid: query?.hltid,
      hlofid: query?.hlofid,
      utmSource: query?.utm_source,
      utmMedium: query?.utm_medium
    }
    sessionStorage?.setItem('heylink', JSON.stringify(heylinkParams))
  }

  /**
   * @returns {object} params heylink
   */
  const getParamsFromSession = () => {
    if (!process.client) { return {} }
    const heylinkStr = sessionStorage?.getItem('heylink')
    if (!heylinkStr) { return {} }
    const heylinkParams = JSON.parse(heylinkStr)
    return heylinkParams
  }

  const send = (data) => {
    const { $hubble } = useContext()
    $hubble.heylink.send(data)
  }

  /**
   * @param {object} data needed for sending to heylink
   */
  const sendData = (order) => {
    const { hltid } = getParamsFromSession()

    if (!hltid) { return }

    const app = useContext()
    const { getCategoryForCartItemGroup } = useTlmCart(app)
    const { getCategorySlugById } = useCategories(app.$hubble)
    const formattedData = formatData({ hltid, order, getCategoryForCartItemGroup, getCategorySlugById })

    send(formattedData)
  }



  return {
    storeParamsToSession,
    sendData
  }
}
